import React, { useEffect, useState } from "react";
import SideBarBack from "../../components/SidebarBack";
import { useDispatch } from "react-redux";
import {
  setDrawerActiveMenu,
  setIsDrawerActive,
} from "../../store/features/webUtilitiesSlice";
import secureLocalStorage from "react-secure-storage";
import icon from "../../assets/images/notification/icon.png";
import { formatDistanceToNow, format } from "date-fns";
import {
  GET_MOOD_NOTIFICATION,
  POST_MOOD_NOTIFICATION,
} from "../../config/ApisCollection";
import axios from "axios";

const menuOption = [];

// Get the current time
const currentTime = new Date();

// Initialize a counter for hours
let hourCounter = 0;

// Loop to create 10 entries
for (let i = 0; i < 10; i++) {
  // Subtract the hour counter from the current time to get the older time
  const olderTime = new Date(currentTime);
  olderTime.setHours(currentTime.getHours() - hourCounter);

  // Increment the hour counter by a random value between 10 and 12 for the next iteration
  hourCounter += Math.floor(Math.random() * (12 - 10 + 1) + 10);

  // Push the entry into the menuOption array
  menuOption.push({
    title: "You have successfully burned 200 cal.",
    key: 311 + i, // Incrementing key value
    subtitle: "By eating only salads past 2 weeks",
    src: icon,
    time: olderTime,
    isRead: true,
  });
}

// Reverse the array to have the older times first
menuOption.reverse();

// Function to format date and time
const formatTime = (timeString) => {
  const options = {
    year: "numeric",
    month: "short",
    day: "numeric",
    hour: "numeric",
    minute: "numeric",
    second: "numeric",
  };
  return new Date(timeString).toLocaleString(undefined, options);
};

// Format time property for display
menuOption.forEach((option) => {
  option.time = formatTime(option.time);
});

export default function Menu() {
  const dispatch = useDispatch();
  const [data, setData] = useState(null);
  const accessToken = secureLocalStorage.getItem("accessToken");
  const handleChangeSidebar = async (menu) => {
    secureLocalStorage.removeItem("backMenu");
    await dispatch(setDrawerActiveMenu(menu));
  };

  const handleCloseDrawer = async () => {
    await dispatch(setDrawerActiveMenu(null));
    await dispatch(setIsDrawerActive(false));
  };
  // Function to check if a date is today
  const isToday = (dateString) => {
    const today = new Date();
    const date = new Date(dateString);
    return (
      date.getDate() === today.getDate() &&
      date.getMonth() === today.getMonth() &&
      date.getFullYear() === today.getFullYear()
    );
  };

  // Function to check if a date is a week ago
  const isAWeekAgo = (dateString) => {
    const aWeekAgo = new Date();
    aWeekAgo.setDate(aWeekAgo.getDate() - 7);
    const date = new Date(dateString);
    return date < new Date() && date >= aWeekAgo;
  };

  // Filter items for today and a week ago
  const todayItems = menuOption.filter((item) => isToday(item.time));
  let aWeekAgoItems = menuOption.filter((item) => isAWeekAgo(item.time));

  // Remove items from aWeekAgoItems that are also in todayItems
  aWeekAgoItems = aWeekAgoItems.filter((itemAWeekAgo) => {
    return !todayItems.some((itemToday) => itemToday.key === itemAWeekAgo.key);
  });

  const formatTime = (dateString) => {
    const date = new Date(dateString);
    const now = new Date();

    // If the date is within the past week, show time elapsed
    if (now - date < 7 * 24 * 60 * 60 * 1000) {
      return formatDistanceToNow(date, { addSuffix: true });
    } else {
      // Otherwise, show the date in the format "Nov 12th, 2023"
      return format(date, "MMM do, yyyy");
    }
  };

  const PostNotification = async (item) => {
    const post_body = {
      id: item.id,
      category: item.category,
    };
    const post_header = {
      headers: {
        Authorization: "Bearer " + accessToken,
        "Content-Type": "application/json",
      },
    };
    await axios
      .post(POST_MOOD_NOTIFICATION, post_body, post_header)
      .then((response) => {
        //--------------------------

        window.location.href = item.blogUrl;
        //-------------------------
      });
  };

  const GetNotificationList = async () => {
    const post_body = {
      headers: {
        Authorization: "Bearer " + accessToken,
        "Content-Type": "application/json",
      },
      body: {},
    };
    await axios.get(GET_MOOD_NOTIFICATION, post_body).then((response) => {
      //--------------------------
      setData(response.data);
      //-------------------------
    });
  };

  useEffect(() => {
    GetNotificationList();
  }, []);

  return (
    <div className="w-full h-full">
      <div className="w-full flex mb-2">
        <SideBarBack handleCloseDrawer={handleCloseDrawer} />
      </div>
      <div className="flex flex-col gap-2 mt-6 w-10/12 mx-auto pb-14">
        {data && data.length > 0 ? (
          <>
            <div className="category">
              <h2 className="text-sm font-medium">Today</h2>
              {data.map((item, index) => (
                <div
                  key={index}
                  className={`my-2 flex gap-3 mb-3  border-b border-[#ddd]	cursor-pointer`}
                  onClick={() => {
                    PostNotification(item);
                  }}
                >
                  <div className="mt-1 content-center	">
                    <img
                      src={item?.imgUrl}
                      alt={item?.title}
                      className="w-[120px] rounded"
                    />
                  </div>
                  <div className="">
                    <p
                      className={`text-[12px] font-medium ${item.isRead &&
                        "text-[#FE7701]"}`}
                    >
                      {" "}
                      {item?.title?.slice(0, 25)}...
                    </p>
                    <p className="text-xs font-[10px]">
                      {" "}
                      {item?.description?.slice(0, 60)}...
                    </p>
                    <p className="text-xs mt-1 font-bold">
                      {" "}
                      {/* {formatTime(item?.time)} */}
                    </p>
                  </div>
                </div>
              ))}
            </div>
          </>
        ) : (
          <>
            <p className="text-center">No notification</p>
          </>
        )}
      </div>
    </div>
  );
}
